import getCollection from './getCollection'
import getObject from './getObject'
import updateDataById from 'actions/base/updateDataById'

const updateBooking = async (id, booking) => updateDataById(id, getCollection, getObject(booking))

export default updateBooking
